var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 16,
  viewBox: "0 0 13 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 10.9725L12.5 10.5369L12.5 10.1789L12.5 9.9725C12.5 9.9725 12.5 9.9725 12.5 9.72099L12.5 9.45451L12.5 8.9725L12.5 5.9725C12.5 5.44206 12.2893 4.93336 11.9142 4.55828C11.5391 4.18321 11.0304 3.9725 10.5 3.9725L5.49999 3.9725C4.96956 3.9725 4.46085 4.18321 4.08578 4.55828C3.71071 4.93336 3.49999 5.44206 3.49999 5.9725L3.49999 13.9725C3.49999 14.5029 3.71071 15.0116 4.08578 15.3867C4.46085 15.7618 4.96956 15.9725 5.49999 15.9725L10.5 15.9725C11.0304 15.9725 11.5391 15.7618 11.9142 15.3867C12.2893 15.0116 12.5 14.5029 12.5 13.9725L12.5 10.9725Z",
  fill: "#A7B2CD"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41422 0.585786C8.7893 0.960859 9.00001 1.46957 9.00001 2L4.00001 2C2.89544 2 2.00001 2.89543 2.00001 4L2.00001 12C1.46958 12 0.96087 11.7893 0.585798 11.4142C0.210725 11.0391 1.09838e-05 10.5304 1.1007e-05 10L1.13567e-05 2C1.13799e-05 1.46957 0.210726 0.960859 0.585798 0.585786C0.960871 0.210713 1.46958 -4.82155e-07 2.00001 -4.58969e-07L7.00001 -2.40412e-07C7.53044 -2.17226e-07 8.03915 0.210713 8.41422 0.585786Z",
  fill: "#A7B2CD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.831f131770da928907c54c4ff50d37e7.svg";